module.exports = __webpack_public_path__ + "media/images/gallery/constellations/vulpecula/vul_lines-94783ebe9624f05e69cc76223b7e84c5.gif";